#import "./TripFragment.graphql"
#import "../../../../../../common/graphql/EntityDocumentsFields.graphql"

query Trip($id: UUID!) {
  trip(id: $id) {
    id
    __typename
    travelerId
    traveler {
      _fullName
    }
    _stopsValidation
    _isDeletable
    _isUpdatable
    _rowTimestamp
    _isEnvironmentalsExist
    travelerReferenceName
    _requiredApprovalDocuments
    _isApprovalDocumentsRequired
    entityDocumentsByEntityId(
      orderBy: [DOCUMENT_POSITION_ASC, _CREATED_DATE_DESC, FILE_REFERENCE_ASC]
    ) {
      nodes {
        ...EntityDocumentsFields
      }
      totalCount
    }
    tripHistoriesByEntityId {
      nodes {
        crudOperation
        pointInTimeDate
        tenantUserName
      }
    }
    notesByEntityId(orderBy: _CREATED_DATE_DESC) {
      nodes {
        id
        _createdByUserName
        _createdDate
        noteComment
        isShared
        _isUpdatable
        _rowTimestamp
        _isDeletable
      }
    }
    traveler {
      id
      _fullName
      _isUpdatable
      _isAliasInvoked
      _isAliasOriginalNameViewable
      _pickupAddress
      isEconomyClassPreferred
      isBusinessClassPreferred
      isFirstClassPreferred
      vendorNumber
      _isApproved
      department {
        name
      }
      userOccupation {
        userOccupationTitle
      }
      travelerAddressesByTravelerId(orderBy: IS_PRIMARY_DESC) {
        nodes {
          id
          _rowTimestamp
          addressLine1
          addressLine2
          cityName
          countryId
          stateRegionId
          postalCode
          telephoneNumber
          emailAddress
          isGroundTransferAddress
          isDeliveryAddress
          isPrimary
          stateRegion {
            stateRegion
            country {
              country
            }
          }
        }
      }

      travelPolicy {
        id
        isCompanion
        description
        isContractual
        isDefaultCustomizable
        companyCurrency {
          isoCode
        }
      }
      _travelPolicyAllowances(
        orderBy: TRAVEL_POLICY_EXPENDITURE_TYPE_BY_EXPENDITURE_TYPE_ID__SORT_ORDER_ASC
      ) {
        nodes {
          id
          expenditureType {
            expenditureType
          }
          allowanceOverrideAmount
          _allowanceDescription
          isAllowanceCustomizable
          _travelerPolicyAllowanceRowTimestamp
          _travelerPolicyAllowanceId
        }
      }
    }
    controlTotalAmount
    airfareAmount
    accommodationAmount
    vehicleRentalAmount
    transportationAmount
    specialInstructions
    comments
    _isOverBudget
    tripLocator
    travelAuthorizationId
    travelAuthorization {
      _isPlanningPhase
      currency {
        id
        isoCode
        currencySymbol
      }
    }
    warningInfo1
    warningInfo2
    warningInfo3
    warningValue1
    warningValue2
    warningValue3
    tripItems {
      nodes {
        ...TripItemFragment
      }
    }
    entityEnvironmentalsByEntityId {
      nodes {
        environmentalMetric {
          environmentalMetric
          layoutType
        }
        description
        endDate
        startDate
        _rowTimestamp
        _createdDate
        id
        _isDeletable
        _isUpdatable
        environmentalMetricId
        entityEnvironmentalItems(
          orderBy: ENVIRONMENTAL_IMPACT_TYPE_BY_ENVIRONMENTAL_IMPACT_TYPE_ID__SORT_ORDER_ASC
        ) {
          nodes {
            __typename
            carbonCreditsAmount
            entityEnvironmentalId
            environmentalImpactTypeId
            _isIntegerFormat
            _isFloatFormat
            _isAmountFormat
            feet
            gallons
            hours
            id
            kilogram
            kilometers
            kilowattHours
            litres
            meters
            metricTonnes
            miles
            omissionsEquivalent
            pounds
            quantity
            therms
            tons
            yards
            _rowTimestamp
            _isUpdatable
            _isDeletable
          }
        }
      }
    }
  }
}
